// The root DOM node the React app mounts into. Non-null because `main.*.tsx`
// asserts this exists at boot via the same lookup — no consumer in the app
// should need to defensively check for it.
export const getRootElement = () => document.getElementById('root');
// Scroll the app to the top of `#root`. Used when arriving at a new page that
// should start at the top regardless of where the user was on the previous page.
export const scrollAppToTop = () => {
    getRootElement().scrollTo({ top: 0 });
};
export const scrollAppToElement = (target) => {
    const element = target && 'current' in target ? target.current : target;
    element === null || element === void 0 ? void 0 : element.scrollIntoView({ behavior: 'smooth' });
};
